/* Micromini Quick Cart + Meta Pixel events */
(function(){
  'use strict';

  function money(cents){
    var cur = window.mmxCurrency || 'INR';
    var symbol = cur === 'INR' ? '₹' : '';
    var n = (cents/100);
    return symbol + n.toLocaleString('en-IN', {maximumFractionDigits: n % 1 === 0 ? 0 : 2});
  }

  function track(event, data){
    if(window.fbq){ try { fbq('track', event, data || {}); } catch(e){} }
  }

  var drawer  = document.getElementById('mmxDrawer');
  var overlay = document.getElementById('mmxDrawerOverlay');

  var MMX = {
    opening: false,

    open: function(){
      if(!drawer) return;
      drawer.classList.add('is-open');
      if(overlay) overlay.classList.add('is-open');
      drawer.setAttribute('aria-hidden','false');
      document.body.style.overflow = 'hidden';
    },
    close: function(){
      if(!drawer) return;
      drawer.classList.remove('is-open');
      if(overlay) overlay.classList.remove('is-open');
      drawer.setAttribute('aria-hidden','true');
      document.body.style.overflow = '';
    },

    add: function(variantId, qty, btn){
      qty = qty || 1;
      if(btn){ btn.classList.add('mmx-loading'); btn.disabled = true; }
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: {'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify({ id: variantId, quantity: qty })
      })
      .then(function(r){ return r.json(); })
      .then(function(item){
        track('AddToCart', {
          content_ids: [String(item.product_id)],
          content_name: item.product_title,
          content_type: 'product',
          value: (item.final_line_price||item.final_price)/100,
          currency: window.mmxCurrency || 'INR'
        });
        return MMX.refresh();
      })
      .then(function(){ MMX.open(); })
      .catch(function(){ window.location = '/cart'; })
      .finally(function(){ if(btn){ btn.classList.remove('mmx-loading'); btn.disabled = false; } });
    },

    changeQty: function(key, qty){
      return fetch('/cart/change.js', {
        method:'POST', headers:{'Content-Type':'application/json'},
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function(r){ return r.json(); }).then(function(){ return MMX.refresh(); });
    },

    refresh: function(){
      return fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart){
        MMX.render(cart);
        return cart;
      });
    },

    render: function(cart){
      var body = document.getElementById('mmxDrawerBody');
      var empty = document.getElementById('mmxDrawerEmpty');
      var foot = document.getElementById('mmxDrawerFoot');
      var upsell = document.getElementById('mmxDrawerUpsell');
      var count = document.getElementById('mmxDrawerCount');
      var subtotal = document.getElementById('mmxDrawerSubtotal');

      // header cart badge sync
      document.querySelectorAll('.mmx-cart-dot').forEach(function(d){ d.textContent = cart.item_count; d.style.display = cart.item_count>0?'':'none'; });
      var hdrCart = document.querySelector('.mmx-cart-btn');
      if(hdrCart && cart.item_count>0 && !hdrCart.querySelector('.mmx-cart-dot')){
        var dot=document.createElement('span'); dot.className='mmx-cart-dot'; dot.textContent=cart.item_count; hdrCart.appendChild(dot);
      }

      if(count) count.textContent = cart.item_count;
      if(subtotal) subtotal.textContent = money(cart.total_price);

      if(cart.item_count === 0){
        if(body) body.innerHTML = '';
        if(empty) empty.hidden = false;
        if(foot) foot.hidden = true;
        if(upsell) upsell.hidden = true;
        return;
      }
      if(empty) empty.hidden = true;
      if(foot) foot.hidden = false;

      var html = '';
      cart.items.forEach(function(it){
        var img = it.image ? it.image.replace(/(\.[^.]+)(\?.*)?$/, '_120x$1') : '';
        var compare = '';
        if(it.original_line_price > it.final_line_price){
          compare = '<span class="mmx-di-was">'+money(it.original_line_price)+'</span>';
        }
        html += ''+
        '<div class="mmx-di" data-key="'+it.key+'">'+
          '<a class="mmx-di-img" href="'+it.url+'">'+(img?'<img src="'+img+'" alt="" width="60" height="60" loading="lazy">':'')+'</a>'+
          '<div class="mmx-di-info">'+
            '<p class="mmx-di-vendor">'+(it.vendor||'')+'</p>'+
            '<a class="mmx-di-name" href="'+it.url+'">'+it.product_title+'</a>'+
            '<div class="mmx-di-bottom">'+
              '<div class="mmx-di-qty">'+
                '<button type="button" data-mmx-dec="'+it.key+'" aria-label="Decrease">−</button>'+
                '<span>'+it.quantity+'</span>'+
                '<button type="button" data-mmx-inc="'+it.key+'" aria-label="Increase">+</button>'+
              '</div>'+
              '<div class="mmx-di-price">'+money(it.final_line_price)+compare+'</div>'+
            '</div>'+
          '</div>'+
          '<button class="mmx-di-remove" data-mmx-remove="'+it.key+'" aria-label="Remove">'+
            '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.8" width="14" height="14"><path d="M4 4l12 12M16 4L4 16"/></svg>'+
          '</button>'+
        '</div>';
      });
      if(body) body.innerHTML = html;

      MMX.giftbar(cart.total_price);
      MMX.loadUpsell(cart);
    },

    giftbar: function(total){
      var bar = document.getElementById('mmxGiftbar');
      if(!bar) return;
      var threshold = parseInt(bar.dataset.threshold) || 0;
      if(threshold <= 0){ bar.style.display='none'; return; }
      var txt = document.getElementById('mmxGiftbarText');
      var fill = document.getElementById('mmxGiftbarFill');
      var pct = Math.min(100, Math.round(total/threshold*100));
      if(fill) fill.style.width = pct + '%';
      if(total >= threshold){
        if(txt) txt.innerHTML = '🎉 ' + (bar.dataset.unlocked || 'Unlocked!');
        bar.classList.add('is-unlocked');
      } else {
        var remain = money(threshold - total);
        if(txt) txt.innerHTML = (bar.dataset.label || 'Spend {amount} more').replace('{amount}', '<strong>'+remain+'</strong>');
        bar.classList.remove('is-unlocked');
      }
    },

    loadUpsell: function(cart){
      var wrap = document.getElementById('mmxDrawerUpsell');
      var row = document.getElementById('mmxUpsellRow');
      if(!wrap || !row || !cart.items.length) return;
      var pid = cart.items[0].product_id;
      var inCart = cart.items.map(function(i){ return i.product_id; });
      fetch('/recommendations/products.json?product_id='+pid+'&limit=4&intent=complementary')
        .then(function(r){ return r.json(); })
        .then(function(d){
          var recs = (d.products||[]).filter(function(p){ return inCart.indexOf(p.id)===-1; }).slice(0,2);
          if(!recs.length){ wrap.hidden = true; return; }
          row.innerHTML = recs.map(function(p){
            var v = p.variants[0];
            var img = p.featured_image ? p.featured_image.replace(/(\.[^.]+)(\?.*)?$/, '_120x$1') : '';
            return '<div class="mmx-up-card">'+
              (img?'<img src="'+img+'" alt="" width="44" height="44">':'')+
              '<div class="mmx-up-info"><p class="mmx-up-name">'+p.title+'</p><p class="mmx-up-price">'+money(v.price)+'</p></div>'+
              '<button class="mmx-up-add" data-mmx-quickadd="'+v.id+'" aria-label="Add">+</button>'+
            '</div>';
          }).join('');
          wrap.hidden = false;
        }).catch(function(){ wrap.hidden = true; });
    }
  };

  window.MMXCart = MMX;

  // ---- Event delegation ----
  document.addEventListener('click', function(e){
    var t = e.target.closest('[data-mmx-cart-toggle]');
    if(t){ e.preventDefault(); MMX.refresh().then(MMX.open); return; }

    if(e.target.closest('[data-mmx-cart-close]')){ e.preventDefault(); MMX.close(); return; }

    var qa = e.target.closest('[data-mmx-quickadd]');
    if(qa){ e.preventDefault(); MMX.add(qa.getAttribute('data-mmx-quickadd'), 1, qa); return; }

    var dec = e.target.closest('[data-mmx-dec]');
    if(dec){ var row=dec.closest('.mmx-di'); var q=parseInt(row.querySelector('.mmx-di-qty span').textContent)-1; MMX.changeQty(dec.getAttribute('data-mmx-dec'), Math.max(0,q)); return; }
    var inc = e.target.closest('[data-mmx-inc]');
    if(inc){ var row2=inc.closest('.mmx-di'); var q2=parseInt(row2.querySelector('.mmx-di-qty span').textContent)+1; MMX.changeQty(inc.getAttribute('data-mmx-inc'), q2); return; }
    var rm = e.target.closest('[data-mmx-remove]');
    if(rm){ MMX.changeQty(rm.getAttribute('data-mmx-remove'), 0); return; }

    var co = e.target.closest('[data-mmx-checkout]');
    if(co){ track('InitiateCheckout'); /* allow default nav */ return; }
  });

  // Intercept product ATC forms marked for AJAX
  document.addEventListener('submit', function(e){
    var form = e.target.closest('form[data-mmx-atc]');
    if(!form) return;
    e.preventDefault();
    var id = form.querySelector('[name="id"]').value;
    var qtyEl = form.querySelector('[name="quantity"]');
    var qty = qtyEl ? parseInt(qtyEl.value) || 1 : 1;
    var btn = form.querySelector('[type="submit"]');
    MMX.add(id, qty, btn);
  });

  // ESC closes
  document.addEventListener('keydown', function(e){ if(e.key==='Escape') MMX.close(); });

  // Initial cart sync (badge)
  if(document.getElementById('mmxDrawer')){ MMX.refresh(); }
})();
